import { IModelEntity } from '@pit/core';
import { IDtoMandator } from './dto.mandator.interface';

export interface IDtoResourceFaultType extends IModelEntity {

    code?: string;
    description?: string;
    isVisible?: boolean;

    mandator?: IDtoMandator;

}
